export default __webpack_public_path__ + "static/media/ca_banner.44d93d85.png";